import React from 'react';
import PropTypes from 'prop-types';
import {
  FeedbackContainer,
  SuccessIcon,
  FailureIcon,
  WarningIcon,
  OrangeWarningIcon,
  InfoIcon,
  StarIcon
} from './styled';

const Feedback = ({ children, variant = 'success', topAlignIcon, className }) => {
  return (
    <FeedbackContainer
      variant={variant}
      topAlignIcon={topAlignIcon}
      className={className}
    >
      {variant === 'success' && <SuccessIcon />}
      {(variant === 'failure' || variant === 'failureTransparent') && <FailureIcon />}
      {variant === 'warning' && <WarningIcon />}
      {variant === 'warningOrange' && <OrangeWarningIcon />}
      {variant === 'info' && <InfoIcon />}
      {variant === 'infoYellow' && <StarIcon />}
      <span>{children}</span>
    </FeedbackContainer>
  );
};

Feedback.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.oneOf([
    'success',
    'failure',
    'failureTransparent',
    'warning',
    'warningOrange',
    'info',
    'infoYellow'
  ]),
  className: PropTypes.string,
  topAlignIcon: PropTypes.bool
};

export default Feedback;
